// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a big_ss","PhotoTitleEditForm__cancelBtn":"iy_b big_sw big_sv"};